var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCricket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 465 465",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M408.1,790.36c-4-0.8-8,1.8-8.8,5.9c-5.3,26.2-15.3,50.8-32.7,79.7c-2.1,3.6-1,8.2,2.6,10.3c1.3,0.8,2.6,1.1,3.9,1.1 c2.6,0,5-1.3,6.4-3.7c18.3-30.4,28.9-56.5,34.5-84.5C414.8,795.16,412.2,791.16,408.1,790.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.32,
    y: 734.124,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -28.2602 1491.7417)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.693,
    y: 842.467,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -431.998 1541.1948)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.844,
    y: 804.948,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 622.735 141.6802)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.692,
    y: 730.454,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 591.9841 66.9372)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.342,
    y: 767.733,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 607.4029 104.265)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.844,
    y: 692.963,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 576.3555 29.6861)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.335,
    y: 655.712,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 560.9943 -7.7354)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.557,
    y: 618.292,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 545.4363 -45.0157)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.964,
    y: 883.536,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -388.8769 1641.194)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.328,
    y: 846.13,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -298.643 1603.7579)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.97,
    y: 771.53,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -118.47 1529.1877)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.677,
    y: 808.865,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 -208.5332 1566.5532)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.683,
    y: 696.859,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 61.8737 1454.547)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.962,
    y: 659.524,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 151.9128 1417.1716)",
    width: 15,
    height: 35.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,608.16c-43.9-43.7-102.2-67.8-164.2-67.8c-62.5,0-120.9,24.1-164.7,67.8C24.1,651.86,0,710.36,0,772.86 c0,62,24.1,120.3,67.8,164.2c43.9,44,102.4,68.3,164.7,68.3c61.9,0,120.2-24.3,164.2-68.3s68.3-102.4,68.3-164.2 C465,710.56,440.7,652.06,396.7,608.16z M15,772.86c0-119.9,97.6-217.5,217.5-217.5c35.5,0,69,8.5,98.6,23.7L38.7,871.46 C23.6,841.86,15,808.36,15,772.86z M106.8,950.26l19-19l-10.6-10.6l-20.4,20.4c-11.4-9.3-21.8-19.8-31.1-31.1l19.7-19.7 l-10.6-10.6l-18.3,18.3c-2.9-4.1-5.7-8.4-8.3-12.8l298.5-298.5c4.4,2.6,8.6,5.4,12.8,8.3l-10.8,10.8l10.6,10.6l12.3-12.3 c11.3,9.2,21.6,19.4,30.8,30.6l-11.6,12.3l10.9,10.3l9.9-10.5c2.9,4,5.6,8.1,8.2,12.3l-299.1,299.1 C114.6,955.66,110.6,953.06,106.8,950.26z M232.5,990.36c-36.1,0-70.2-8.9-100.2-24.5l293.2-293.2c15.7,30,24.5,64.1,24.5,100.2 C450,892.76,352.4,990.36,232.5,990.36z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 357,
    cy: 904.358,
    r: 7.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.240f3aa56554ef80fdd5bc4ef3aa4bdb.svg";
export { ForwardRef as ReactComponent };